import { render } from "./BaseIconCopy.vue?vue&type=template&id=a3b7bc2c"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconCopy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3b7bc2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3b7bc2c', __exports__)) {
    console.log('reload')
    api.reload('a3b7bc2c', __exports__)
  }
  
  module.hot.accept("./BaseIconCopy.vue?vue&type=template&id=a3b7bc2c", () => {
    console.log('re-render')
    api.rerender('a3b7bc2c', render)
  })

}


export default __exports__